import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=4d2972ed&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2972ed')) {
      api.createRecord('4d2972ed', component.options)
    } else {
      api.reload('4d2972ed', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=4d2972ed&", function () {
      api.rerender('4d2972ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23zog6rzHnfkk/JS/ImageCarousel.vue"
export default component.exports